import dayjs from 'dayjs'

export const makeId = () => (Date.now() + Math.random()).toString(36)

export const ALL_MARKING_PERIODS_ID = '0'

export const resolveCurrentMarkingPeriodId = markingPeriods => {
  if (!markingPeriods?.length) return null

  const now = dayjs()
  const current =
    markingPeriods.find(
      mp => now.isAfter(dayjs(mp.startDate).subtract(1, 'day')) && now.isBefore(dayjs(mp.endDate).add(1, 'day')),
    ) ||
    [...markingPeriods].filter(mp => dayjs(mp.endDate).isBefore(now)).sort((a, b) => dayjs(b.endDate).diff(dayjs(a.endDate)))[0] ||
    [...markingPeriods].sort((a, b) => dayjs(a.startDate).diff(dayjs(b.startDate)))[0]

  return current?.id ?? null
}

export const getStatusColor = status => {
  const s = (status || '').toLowerCase()
  if (['enrolled'].includes(s)) return 'success'
  if (['rejected'].includes(s)) return 'error'
  if (['waitlist'].includes(s)) return 'warning'
  if (['inprogress'].includes(s)) return 'info'
  return 'default'
}
